import { themeColors } from '@/theme/colors';
import { ProgressCircle } from '@lego/connect-components-react';
import { Flex, Text } from '@lego/klik-ui';

const ProcessingView = () => (
  <Flex
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    gap="16px"
    flex="1"
    width="100%"
  >
    <ProgressCircle indeterminate aria-label="Processing file" size="large" />
    <Flex flexDirection="column" alignItems="center" gap="4px">
      <Text className="label-sm-medium">Processing file…</Text>
      <Text className="label-xs-regular" color={themeColors.content.subtle}>
        This may take a moment
      </Text>
    </Flex>
  </Flex>
);

export default ProcessingView;
